import React from 'react';
import { motion } from 'framer-motion';
import { SlideFrame } from '../deck/SlideFrame';
const points = [{
  heading: 'Brands rarely lose on facts',
  body: 'They lose on the distance between what is true and what the prescriber believes at the moment of the decision.'
}, {
  heading: 'That distance is measurable',
  body: 'Rank the criteria, rate every option against them, then set the ratings beside what we can actually defend.'
}, {
  heading: 'And it has only two answers',
  body: 'Either we change what a prescriber believes, or we change which prescribers we spend against.'
}];
export function PremiseSlide() {
  return <SlideFrame marker="The premise" data-id="element-139" data-mp="2slut2auquzuh">
      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-140" data-mp="2xhs9si9x687s">
        <blockquote className="max-w-[26ch] font-display text-[clamp(26px,4.4vw,74px)] leading-[1.06] tracking-[-0.015em] text-ink" data-id="element-141" data-mp="1h4bmc8hyger6">
          The strategy lives in the gap, not in the message.
        </blockquote>

        <div className="mt-[4.5vh] grid grid-cols-3 gap-[3%]" data-id="element-142" data-mp="1x1g33akxj6d2">
          {points.map((point, index) => <motion.article key={point.heading} className="flex flex-col rounded-2xl border border-ink-line bg-paper-card px-[7%] py-[2.6vh]" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-143" data-mp="1s3myun36smff" data-mpi={index}>
              <h3 className="text-[clamp(13px,1.5vw,25px)] font-semibold leading-[1.25] text-ink" data-id="element-144" data-mp="2b17ohwdrzp13">
                {point.heading}
              </h3>
              <p className="mt-[1.2vh] text-[clamp(11px,1.2vw,19px)] leading-[1.5] text-ink-soft" data-id="element-145" data-mp="2krslxghpqnif">
                {point.body}
              </p>
            </motion.article>)}
        </div>
      </div>
    </SlideFrame>;
}